import gql from "graphql-tag";

export default gql`
  mutation updateOrderStatus(
    $orderId: String!
    $newStatus: OrderStatus!
    $userId: ID
  ) {
    updateOrderStatus(
      orderId: $orderId
      newStatus: $newStatus
      userId: $userId
    ) {
      id
      serviceTitle
      status
      serviceId
      termsAccepted
      serviceSteps {
        label
        step
      }
      fields {
        id
        fieldName
        label
        placeholder
        description
        validation
        type
        required
        value
        step
        order
        file {
          bucket
          region
          key
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutation/UpdateOrderStatus.js